import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {TLeadFilters} from 'src/containers/LeadCompanyClients';
import {listenerMiddleware} from 'src/models';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.AGENTS_COMPANY_CLIENTS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const agentClientsSlice = createSlice({
  name: 'agentCompanyClients',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TLeadFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = agentClientsSlice.actions;
export const selectFilters = (state: TRootState) =>
  state.agentCompanyClients.filters as TLeadFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(
      EStorageKeys.AGENTS_COMPANY_CLIENTS_FILTERS,
      JSON.stringify(action.payload),
    );
  },
});

export default agentClientsSlice.reducer;
